module.exports = __webpack_public_path__ + "img/Mstorybg901.9ea81161.png";